




























































































































































































































































import Vue from 'vue';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { EventBus } from '@/event-bus';

import { User } from '@/models/users/User';
import { State } from '@/models/State';

import SaveProfileRequest from '@/models/profile/SaveProfileRequest';
import DropdownOption from '@/models/misc/DropdownOption';

import accountsService from '@/services/AccountsService';
import locationsService from '@/services/LocationsService';

export default Vue.extend<any, any, any, any>({
  props: ['profile'],
  mixins: [iconsMixin, breakpointsMixin, authMixin],
  data() {
    return {
      loading: false as Boolean,
      editing: false as Boolean,
      saving: false as Boolean,
      statesDdl: [] as DropdownOption[],
      selectedState: null as DropdownOption,
      profiles: [] as User[],
      saveProfileRequest: new SaveProfileRequest(),
      snackMessage: '',
      errorState: false as Boolean,
      snackbar: false as Boolean,
      saveProfileComplete: false as Boolean,
      phoneFormatted: null,
      validProfile: true as Boolean,
    };
  },
  async mounted() {
    this.onMounted();
  },
  created() {
    this.edit(this.user.accountId, this.user.userId);
  },
  methods: {
    onMounted() {
      EventBus.$on('settings-profile-list-edit', this.updateEditForm);
      EventBus.$on('settings-profile-list-edit', this.renderNumber);
      this.updateAndReload();

      this.$refs.profileForm.resetValidation();
    },
    mapStates(state: State) {
      return new DropdownOption(state.id, state.name);
    },
    stateChanged(selected: any) {
      locationsService.getListOfStates('USA').then((x) => {
        this.statesDdl = x.map(this.mapStates);
        const state = this.statesDdl.find((x) => x.text == selected.text);
        this.saveProfileRequest.state = selected.text;
        this.selectedState = state;
      });
    },
    edit(accountId, userId) {
      this.editing = true;
      accountsService.getUser(accountId, userId).then((x) => {
        this.profiles = x;

        const profile = new SaveProfileRequest();
        profile.userId = x.userId;
        profile.firstName = x.firstName;
        profile.lastName = x.lastName;
        profile.email = x.email;
        profile.title = x.title;
        profile.department = x.department;
        profile.phone = x.phone;
        profile.address1 = x.address1;
        profile.city = x.city;
        profile.state = x.state;
        profile.postalCode = x.postalCode;
        profile.newPassword = x.newPassword;

        this.editing = false;

        EventBus.$emit('settings-profile-list-edit', profile);
      });
    },
    renderNumber(profile) {
      this.saveProfileRequest = profile;
      this.phoneFormatted = profile.phone;
    },
    updateEditForm(profile) {
      this.saveProfileRequest = profile;
      this.selectedState = profile.state;
      locationsService.getListOfStates('USA').then((x) => {
        this.statesDdl = x.map(this.mapStates);
      });
    },
    reverseFormat() {
      if (this.phoneFormatted)
        this.saveProfileRequest.phone = this.phoneFormatted
          .replace('(', '')
          .replace(')', '')
          .replace(' ', '')
          .replace('-', '');
    },
    validateEmail(input) {
      if (!input) return;

      var validRegex =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (input.match(validRegex)) {
        return true;
      } else {
        return false;
      }
    },
    save() {
      this.$refs.profileForm.validate();

      if (!this.validEmailInput) {
        return;
      }

      if (this.validProfile) {
        this.saving = true;
        this.reverseFormat();

        accountsService
          .update(
            this.user.accountId,
            this.user.userId,
            this.saveProfileRequest
          )
          .then(() => {
            this.saving = false;
            this.$emit('updateAndReload');
            this.snackbar = true;
            this.errorState = false;
            this.snackMessage = 'Success! Profile updated.';
            this.saveProfileComplete = true;
            this.changePassword = false;
          });
        this.updateAndReload();
      }
    },
    updateAndReload() {
      if (this.valid) {
        this.$emit(
          'updateAndReload',
          this.accountId,
          this.userId,
          this.saveProfileRequest
        );
      }
    },
  },
  computed: {
    validEmailInput() {
      return this.validateEmail(this.saveProfileRequest.email);
    },
  },
});
